import Loading from '../../Utils/Loading';

function LoadingAllScreen() {
  return (
    <div className="min-h-[70dvh] flex items-center justify-center ">
      <Loading />
    </div>
  );
}

export default LoadingAllScreen;
